export default "__VITE_ASSET___mVBx1wQ__"